(function () {
    'use strict';

    function syncCaptionToggleTabOrder(swiperEl) {
        swiperEl.querySelectorAll('.swiper-slide .caption-toggle').forEach(function (toggleEl) {
            var slideEl = toggleEl.closest('.swiper-slide');
            var isActive = slideEl && slideEl.classList.contains('swiper-slide-active');
            toggleEl.setAttribute('tabindex', isActive ? '0' : '-1');
        });
    }

    function initCaptionToggles(scope) {
        scope.querySelectorAll('.swiper-slide .caption-toggle').forEach(function (toggleEl) {
            var slideEl = toggleEl.closest('.swiper-slide');
            var captionEl = slideEl ? slideEl.querySelector('figcaption') : null;

            if (!slideEl || !captionEl) return;

            // Ensure hidden by default even if a browser/style race renders it once.
            captionEl.style.display = 'none';
            toggleEl.setAttribute('role', 'button');
            toggleEl.setAttribute('tabindex', '-1');
            toggleEl.setAttribute('aria-expanded', 'false');
            toggleEl.setAttribute('aria-label', 'Show caption');

            function toggleCaption() {
                var isOpen = captionEl.style.display !== 'none';
                captionEl.style.display = isOpen ? 'none' : 'block';
                toggleEl.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
                toggleEl.setAttribute('aria-label', isOpen ? 'Show caption' : 'Hide caption');
            }

            toggleEl.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                toggleCaption();
            });

            toggleEl.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleCaption();
                }
            });
        });
    }

    function initSlider() {
        if (typeof Swiper === 'undefined') return;

        document.querySelectorAll('.slider-swiper').forEach(function (swiperEl) {
            var section = swiperEl.closest('.section.section--slider');
            if (!section) return;
            initCaptionToggles(section);

            var paginationEl = section.querySelector('.swiper-pagination');
            var nextEl = section.querySelector('.swiper-button-next');
            var prevEl = section.querySelector('.swiper-button-prev');

            var config = {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 24,
                slidesPerGroup: 1,
                speed: 700,
                centeredSlides: false,

                breakpoints: {
                    0: { slidesPerView: 'auto' },
                    576: { slidesPerView: 'auto' },
                    992: { slidesPerView: 'auto' },
                },
            };

            if (paginationEl) {
                config.pagination = { el: paginationEl, clickable: true };
            }
            if (nextEl && prevEl) {
                config.navigation = { nextEl: nextEl, prevEl: prevEl };
            }

            var swiper = new Swiper(swiperEl, config);
            syncCaptionToggleTabOrder(swiperEl);

            swiper.on('slideChange', function () {
                syncCaptionToggleTabOrder(swiperEl);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSlider);
    } else {
        initSlider();
    }
})();
